import type { NamespaceSchema } from './types';

// Field paths match apps/web/src/lib/cms/currency.ts (interface
// RawSettings). The `displayCurrencies` array (`{ code, symbol, rateToPrimary }`)
// is shown read-only on the Currency page (CurrencyRatesPanel) and maintained
// via the "Refresh from FX provider" button -> POST /admin/configs/
// currency-settings/refresh-fx, the single canonical writer of FX rates.
// Primary + format fields below cover the rest of the day-to-day surface.

export const currencySettings: NamespaceSchema = {
  namespace: 'currency-settings',
  label: 'Currency',
  description: 'Primary currency (booking-of-record) + display formatting. Read by every storefront page that prints money.',
  sections: [
    {
      label: 'Primary',
      fields: [
        { kind: 'text', key: 'primary', label: 'Primary currency code', default: 'EUR', placeholder: 'EUR', description: 'ISO 4217 — all bookings + Stripe charges + wallet balances are denominated here.' },
        { kind: 'text', key: 'symbol', label: 'Primary symbol', default: '€', placeholder: '€' },
      ],
    },
    {
      label: 'Display formatting',
      fields: [
        { kind: 'select', key: 'symbolPosition', label: 'Symbol position', default: 'before', options: [
          { value: 'before', label: 'Before amount (€140)' },
          { value: 'after', label: 'After amount (140 €)' },
        ] },
        { kind: 'number', key: 'decimalPlaces', label: 'Decimal places', default: 2, min: 0, max: 4 },
      ],
    },
    {
      label: 'Buy/sell ledger',
      description: 'Pair rates are maintained in the matrix panel below. This toggle is the escape hatch for non-prod environments only.',
      fields: [
        {
          kind: 'boolean',
          key: 'allowRuntimeCrossFromEur',
          label: 'Allow runtime cross-from-EUR fallback (DEV/STAGING ONLY)',
          default: false,
          description: 'When ON, missing pair rates fall back to cross-from-EUR at lock time. Reintroduces the EUR-pivot FX offsets this ledger eliminates. Production MUST keep this OFF — bid-lock will hard-fail (409 missing_pair_rate) and the booking lands on the stuck-bookings queue for an operator to set the pair.',
        },
      ],
    },
  ],
};
